export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-480w.a8865a17.png";